import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';

const initialState = {
  applyList: { data: [], loading: false },
  applyLogs: { data: [], total: 0, pageNum: 0, pageSize: 0, loading: false },
  auditList: { data: [], loading: false },
  auditLogs: { data: [], total: 0, pageNum: 0, pageSize: 0, loading: false },
  allPrivateBrands: { data: [], loading: false },
  brandAuthLogs: { data: [], total: 0, pageNum: 0, pageSize: 0, loading: false },
  confirm: { type: '', title: '', content: '', visible: false, loading: false },
  processing: false,
  loading: false,
};

export default { namespaced: true, state: initialState, actions, mutations } as IStore<IModuleState>;
